/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react'
import { ShimmerThumbnail } from "react-shimmer-effects";


const AdorSupportSkeleton = () => {

    return (
        <div className="md:px-[46px] px-4 sm:mt-6 mt-3.5">
            <h1 className="sm:text-sm50 text-xl font-semibold text-[#000000]">Ador Support</h1>
            <div className="flex sm:flex-row flex-col -mx-3.5 mt-4">
                <div className="xl:w-[20%] lg:w-[30%] sm:w-[50%] w-full px-3.5">
                    <div className="w-full">
                        <ShimmerThumbnail height={150} width={300} rounded />;
                    </div>
                </div>
                <div className="xl:w-[80%] lg:w-[70%] sm:w-[50%] w-full px-3.5 sm:pt-0 pt-5">
                    <div className="w-full">
                        <div className="flex -mx-2.5 flex-wrap">
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />                                  
                                </div>
                            </div>
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />                                  
                                </div>
                            </div>
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />     
                                </div>
                            </div>
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />     
                                </div>
                            </div>
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />     
                                </div>
                            </div>
                            <div className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                    <ShimmerThumbnail height={220} rounded />     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdorSupportSkeleton
